export default "__VITE_ASSET__Dnx4eRpC__"